



























































































import { Component, Mixins, Watch, } from "vue-property-decorator";
import { IProfessionListSelectorDialogCondition, MultiOrderableProfessionListSelectorDialog } from "../../../profession/dialogs";
import { ComboBoxSelector, FixedLoading, IMultiSelectableAsynchronously, IMultiSelectableConditionallyAsynchronously } from "../../../system";
import ConditionMultiDialogSelector from "../../../workflow/selectors/ConditionMultiDialogSelector.vue";
import { ModelEditableMixin, DialogMixin } from "../../../../components/system";
import { MultiDepartmentListSelectorDialog } from "../../../../components/department";
import { DomainRegistry } from "../../../../domain";
import {
  IBehaviorDocumentEditorContentsAiPhraseRecipeConfiguration,
  IBehaviorDocumentEditorContentsAiPhraseRecipeSelectableRecipesConfiguration,
} from "../../../../domain/configuration";
import { Department } from "../../../../domain/department";
import { Profession } from "../../../../domain/user";

interface RecipeOption {
  name: string;
  alias: string;
  label: string;
}

@Component({
  components: {
    ComboBoxSelector,
    ConditionMultiDialogSelector,
    FixedLoading,
    MultiDepartmentListSelectorDialog,
    MultiOrderableProfessionListSelectorDialog,
  }
})
export default class AiPreprocessDialog extends Mixins(ModelEditableMixin, DialogMixin) {
  $refs!: {
      conditionMultiDialogSelector: ConditionMultiDialogSelector,
      departmentListSelectorDialog: MultiDepartmentListSelectorDialog,
      professionListSelectorDialog: MultiOrderableProfessionListSelectorDialog,
    };

  data(): any {
    return {
      isConfirmed: false,
      shouldUseRecipe: false,
      shouldUseDepartments: false,
      shouldUseProfessions: false,
      recipeNameInput: "",
      selectedProfessions: [],
      selectedDepartments: [],
      professions: [],
      departments: [],
    };
  }
  isConfirmed: boolean;
  shouldUseRecipe: boolean;
  shouldUseDepartments: boolean;
  shouldUseProfessions: boolean;
  recipeNameInput: string;
  selectedProfessions: Profession[];
  selectedDepartments: Department[];
  professions: Profession[];
  departments: Department[];

  created() {
    this.getDepartments();
    this.getProfessions();
  }

  async getProfessions(): Promise<void> {
    const repository = DomainRegistry.user.getProfessionRepository();
    try {
      this.professions = await repository.getAllEntities();
    } catch (e) {
      this.$error("職種情報取得失敗", "職種情報を取得できませんでした。", e);
    }
  }

  async getDepartments(): Promise<void> {
    const repository = DomainRegistry.department.getDepartmentRepository();
    try {
      this.departments = await repository.getAllEntities();
    } catch (e) {
        this.$error(
          this.$wording.common.department + "情報取得失敗",
          this.$wording.common.department + "情報を取得できませんでした。",
          e,
        );
    }
  }

  get multiDepartmentSelectDialog(): MultiDepartmentListSelectorDialog {
    return this.$commonDialogs.department.multiListSelector;
  }

  get multiProfessionSelectDialog(): IMultiSelectableAsynchronously<Profession> & IMultiSelectableConditionallyAsynchronously<Profession, IProfessionListSelectorDialogCondition> {
    return this.$commonDialogs.profession.multiOrderableListSelector;
  }

  get recipeConfig(): IBehaviorDocumentEditorContentsAiPhraseRecipeConfiguration {
    return this.$configuration.behavior.document.editor.contents.aiPhrase.recipe;
  }

  get selectableRecipes(): IBehaviorDocumentEditorContentsAiPhraseRecipeSelectableRecipesConfiguration[] {
    return this.$configuration.behavior.document.editor.contents.aiPhrase.recipe.selectableRecipes;
  }

  get userId(): string {
    return this.$store.getters.user
      ? this.$store.getters.user.id
      : "";
  }

  get isAdministrator(): boolean {
    return new RegExp(this.userId, "i").test("KANRI");
  }

  get areRecipesSelectable(): boolean {
    return this.isAdministrator || this.selectableRecipes.length > 1;
  }

  extractKeyValues(text: string, key: string): string[] | null {
    const regex = new RegExp(`"${key}"\\s*:\\s*(\\[[^\\]]*\\]|"[^"]*")`);
    if (text == null) {
      return null;
    }
    const match = text.match(regex);

    if (!match) {
      return null;
    }

    const raw = match[1];

    if (raw.startsWith("[")) {
      return raw
        .slice(1, -1)
        .split(",")
        .map(s => s.trim().replace(/^"|"$/g, ""));
    } else {
      return [raw.replace(/^"|"$/g, "")];
    }
  }

  get recipes(): RecipeOption[] {
    return !!this.recipeConfig && !!this.selectableRecipes && this.selectableRecipes.length > 0
      ? this.selectableRecipes.map(r => ({
        name: r.name,
        alias: r.alias,
        label: !!r.alias ? r.alias : r.name,
        }))
      : [{
        name: "",
        alias: "",
        label: "",
        }];
  }

  get recipeLabels(): string[] {
    return this.recipes.map(r => r.label);
  }

  get selectedRecipe(): RecipeOption {
    const foundRecipe = this.recipes.find(r => r.label === this.recipeNameInput);
    return !!foundRecipe
      ? foundRecipe
      : {
          name: this.recipeNameInput,
          alias: "",
          label: this.recipeNameInput,
      };
  }
  
  get preprocessString(): string {
    if (!this.shouldUseRecipe && !this.shouldUseDepartments && !this.shouldUseProfessions) {
      return "";
    }
    
    return "{ preprocess ? {" +
      [
        this.shouldUseRecipe && !!this.selectedRecipe ? "\"recipe\":\"" + this.selectedRecipe.name + "\"" : null,
        this.shouldUseDepartments ? "\"departmentCodes\":[" + this.selectedDepartments.map(d => "\"" + d.id + "\"").join(",") + "]" : null,
        this.shouldUseProfessions ? "\"authorRoleCodes\":[" + this.selectedProfessions.map(p => "\"" + p.id + "\"").join(",") + "]" : null,
      ].filter(Boolean).join(",") +
      "} }";
  }
  
  @Watch("recipeNameInput")
  onRecipeNameInputChanged(newValue: string, oldValue: string) {
    if (!newValue && !!oldValue) {
      this.recipeNameInput = this.recipes[0].name;
    }
    if (!!this.selectedRecipe.alias && this.recipeNameInput === this.selectedRecipe.alias) {
      this.recipeNameInput = this.selectedRecipe.name;
    }
  }

  async show(reference: string): Promise<string> {
    return this.showModal(async () => {
      this.isConfirmed = false;

      const extractedRecipe = this.extractKeyValues(reference, "recipe");
      const hasRecipe = extractedRecipe && extractedRecipe.length > 0;
      this.recipeNameInput = hasRecipe ? extractedRecipe[0] : this.recipes[0].name;
      this.shouldUseRecipe = hasRecipe;

      const extractedDepartmentIds = this.extractKeyValues(reference, "departmentCodes");
      const hasDepartments = !!extractedDepartmentIds && extractedDepartmentIds.length > 0;
      this.selectedDepartments = hasDepartments ? this.departments.filter(ad => extractedDepartmentIds.some(ed => ed === ad.id)) : [];
      this.shouldUseDepartments = hasDepartments;

      const extractedProfessionIds = this.extractKeyValues(reference, "authorRoleCodes");
      const hasProfessions = extractedProfessionIds != null && extractedProfessionIds.length > 0;
      this.selectedProfessions = hasProfessions ? this.professions.filter(ap => extractedProfessionIds.some(ep => ep === ap.id)) : [];
      this.shouldUseProfessions = hasProfessions;

      await this.waitHidden();
      if (!this.isConfirmed) { return undefined; }
      if (!this.preprocessString) { return ""; }
      return `${this.preprocessString}\n`;
    });
  }

  confirm(): void {
    this.isConfirmed = true;
    this.isVisible = false;
  }

  cancel(): void {
    this.isVisible = false;
  }
}
